require('./TabInfo.scss');
require('./TabInfo.override.scss');
import React, {Component} from 'react';

const PropTypes = require('prop-types');
const {connect} = require('react-redux');
const {formatText, FormattedText} = require('core/i18n').i18n;
const moment = require('moment');
const { AmountInput } = require('commonsComponents/amountInput');
const FormattedDescription = require('components/commons/FormattedDescription');
const TabbedBoxContent = require('components/commons/tabbedBox/tabbedBoxContent/tabbedBoxContent');
const {amountChanged: growthAmountChanged, periodChanged: growthPeriodChanged} = require('../../actions/growth');
const {selected: globalStockSelected} = require('../../actions/globalStock');
const AnnualReturnChart = require('components/charts/AnnualReturnChart/AnnualReturnChart');
const GlobalStockChart = require('components/charts/GlobalStockChart/GlobalStockChart');
const GlobalStockTable = require('components/charts/GlobalStockTable/GlobalStockTable');
const GrowthChart = require('components/charts/GrowthChart/GrowthChart');
const RiskIndicator = require('components/charts/RiskIndicator/RiskIndicator');
const {
    GRAPH_COLORS,
    INITIAL_AMOUNT,
    INITIAL_PERIOD
} = require('../../constants');
const currencySymbol = require('utilities/currencySymbol');
const {
    getAnnualReturnData,
    getAssetAllocations,
    getGlobalStockData,
    getGrowthBenchmark,
    getGrowthData,
    getMarketCapitalBreakdownData,
} = require('../../selectors/fundDataSelectors');
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
const { recordLinkCommonV2 } = require('commonsUtilities/tagging')

import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'

const {FUND_GLOSSARY} = require('constants/flagBasedFeatures')

class TabInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maxYear: 0,
            yearPeriod: INITIAL_PERIOD,
            growMinAmount: props.growthAmount
        }
    }

    componentWillReceiveProps(nextProps) {
        const {growthData} = this.props;
        if (this.state.maxYear === 0 && growthData.length > 0) {
            this.setState({
                maxYear: Math.floor(moment(growthData[growthData.length - 1].date).diff(moment(growthData[0].date), 'years', true))
            });
        }
    }

    changeGrowthPeriodState = (e) => {
        const {changeGrowthPeriod} = this.props;
        const currentValue = e.target.value;
        const newPeriod = currentValue < 1 ? 1 : parseInt(currentValue);
        this.setState({
            newPeriod
        }, () => {
            changeGrowthPeriod(newPeriod)
        });
    }

    handleGrowthAmount = (growMinAmount) => {
        const {changeGrowthAmount} = this.props;
        if (growMinAmount > 1) {
            this.setState({
                growMinAmount
            }, () => {
                changeGrowthAmount(growMinAmount)
            })
        }
    }

    handleSendTracking = (type) => {
        const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
        recordLinkCommonV2({
            action: 'type',
            format: 'textBox',
            component: 'body',
            element: type,
            eventCategory: 'fundDescriptionInteraction',
            eventAction: 'typeTextBox',
            eventLabel: type,
        }, isNotProduction);
    }

    render() {
        const {
            annualReturnData,
            changeGrowthAmount,
            changeGrowthPeriod,
            fund,
            globalStockData,
            growthAmount,
            growthBenchmark,
            growthData,
            growthPeriod,
            selectedGlobalStock,
            selectGlobalStock,
            flagBasedFeatures
        } = this.props;
        const {maxYear, yearPeriod} = this.state;

        let orderGlobalStockData = globalStockData ? globalStockData.sort((a, b) => parseFloat(b.value) - parseFloat(a.value)) : null;
        let periodGrowth = yearPeriod;
        let maxYearNotChange = maxYear;
        let diffYearsDates = 0;

        if (growthData.length > 0)
            maxYearNotChange = maxYear === 0 ? Math.floor(moment(growthData[growthData.length - 1].date).diff(moment(growthData[0].date), 'years', true)) : maxYear;

        let showErrorMessage = maxYear === 0 ? periodGrowth > maxYearNotChange : periodGrowth > maxYear;

        if (growthData.length > 0)
            diffYearsDates = Math.floor(moment(growthData[growthData.length - 1].date).diff(moment(growthData[0].date), 'years', true));

        let data = growthData.length > 0 ? growthData : null;
        let messageError;
        let valueMessage;

        if (data !== null) {
            if (diffYearsDates < 3) {
                showErrorMessage = true
                periodGrowth = INITIAL_PERIOD;
                messageError = "fundsCard-errorMinYearGraph";
                valueMessage = moment(fund.inceptionDate).format('DD/MM/YYYY');
            } else {
                showErrorMessage = false
            }
        }

        const annualDataToShow = !!annualReturnData ? (
            <React.Fragment>
                <h2 className="tabinfo--title">
                    {formatText('fundsCard-annualProfitabilityTitle')}
                </h2>
                <p className="tabinfo--description">
                    <FormattedDescription value="fundsCard-annualProfitabilityDescription"/>
                </p>
                <AnnualReturnChart
                    data={annualReturnData}
                    fund={fund}
                />
                <aside className="tabinfo--description text-center">
                    <FormattedDescription value="fundsCard-annualProfitabilityDisclaimer"/>
                </aside>
            </React.Fragment>
        ):
            null;

        const labelSearchName = flagBasedFeatures.get(FUND_GLOSSARY)
            ? <FormattedDescription value="fundsCard-liquidatingValuesInfo"/>
            : <FormattedDescription value="fundsCard-updatedInformationDisclaimerNoGlossary"/>
        const amount = growthAmount ? growthAmount : INITIAL_AMOUNT;
        return (
            <TabbedBoxContent visible>
                <div className="tabinfo">
                    {!!data && !!fund.benchmark[0].growthOf10K &&
                    <section className="row">
                        <div className="col-lg-12">
                            <h3 className="tabinfo--title">{formatText('fundsCard-growthTitle')}</h3>
                            <div className="tabinfo--quantify tabinfo__container__row">
                                <div className="tabinfo__container__row__text">
                                    {formatText('fundsCard-growthMessage1')}
                                </div>
                                <div className="tabinfo__container__row__input">
                                    <AmountInput
                                        amount={amount}
                                        onChange={this.handleGrowthAmount}
                                        handleOnFocus={() => this.handleSendTracking('quantity')}
                                    />
                                </div>
                                <div className="tabinfo__container__row__currency">
                                    {currencySymbol(fund.custom ? fund.custom.customPurchaseCurrency : '')}
                                </div>
                                <p>
                                    {formatText('fundsCard-growthMessage2')}
                                    &nbsp;
                                    <input
                                        className="quantify--input smaller"
                                        defaultValue={periodGrowth}
                                        onChange={this.changeGrowthPeriodState}
                                        onClick={() => this.handleSendTracking('years')}
                                    />
                                    &nbsp;
                                    {formatText('fundsCard-growthMessage3')}.
                                </p>
                                {showErrorMessage &&
                                <div className="error-years-message">
                                    <FormattedText value={messageError} injectedStrings={[valueMessage]}/>
                                </div>
                                }
                            </div>
                            <GrowthChart
                                benchmark={growthBenchmark}
                                data={data}
                                fund={fund}
                                dateTruncate={true}
                            />
                        </div>
                    </section>
                    }
                    <section className="row">
                        <div className="col-lg-8 col-xs-12">
                            {annualDataToShow}
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-md-12 col-xs-12">
                            <h2 className="tabinfo--title mt--50">
                                {formatText('fundsCard-investmentStrategyTitle')}
                            </h2>
                            <p className="tabinfo--description">
                                <FormattedDescription value="fundsCard-investmentStrategyDescription"/>
                            </p>
                            <p className="tabinfo--description">
                                {fund.investmentStrategy}
                            </p>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-md-12 col-xs-12">
                            <h2 className="tabinfo--title mt--50">
                                {formatText('fundsCard-stockDistributionTitle')}
                            </h2>
                            <p className="tabinfo--description">
                                <FormattedDescription value="fundsCard-stockDistributionDescription"/>
                            </p>
                        </div>
                    </section>
                    {globalStockData !== null &&
                    <section className="row">
                        <div className="col-lg-8 col-xs-12 tabinfo--fullwidth">
                            <GlobalStockTable
                                colors={GRAPH_COLORS}
                                data={orderGlobalStockData}
                                onMouseEnterRow={i => selectGlobalStock(i)}
                            />
                        </div>
                        <div className="col-lg-4 col-xs-12">
                            <GlobalStockChart
                                activeIndex={selectedGlobalStock}
                                colors={GRAPH_COLORS}
                                data={orderGlobalStockData}
                                textWidth="150px"
                            />
                        </div>
                        <div className="col-lg-12 col-xs-12 tabinfo--updated">
                            {/*<p className="tabinfo--description">La información de distribución del fondo ha sido actualizada el 3 may 2018</p>*/}
                        </div>
                    </section>
                    }
                    <section className="row">
                        <div className="col-lg-12 col-xs-12 tabinfo__information">
                            <p className="information__card information__card--footer">
                                {labelSearchName}
                            </p>
                        </div>
                    </section>
                </div>
            </TabbedBoxContent>
        )
    }
}

TabInfo.propTypes = {
    annualReturnData: PropTypes.array,
    assetAllocationsData: PropTypes.array,
    changeGrowthAmount: PropTypes.func.isRequired,
    changeGrowthPeriod: PropTypes.func.isRequired,
    fund: PropTypes.object.isRequired,
    globalStockData: PropTypes.array,
    growthAmount: PropTypes.number.isRequired,
    growthBenchmark: PropTypes.object.isRequired,
    growthData: PropTypes.array,
    growthPeriod: PropTypes.number.isRequired,
    marketCapitalBreakdownData: PropTypes.array,
    selectGlobalStock: PropTypes.func.isRequired,
    selectedGlobalStock: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    flagBasedFeatures: PropTypes.object.isRequired
};

TabInfo.defaultProps = {
    annualReturnData: [],
    assetAllocationsData: [],
    globalStockData: [],
    growthData: [],
    marketCapitalBreakdownData: [],
};

const mapStateToProps = (state, props) => ({
    annualReturnData: getAnnualReturnData(state, props),
    assetAllocationsData: getAssetAllocations(state, props),
    globalStockData: getGlobalStockData(state, props),
    growthAmount: state.brokerInvestmentFundView.growthAmount,
    growthBenchmark: getGrowthBenchmark(state, props),
    growthData: getGrowthData(state, props),
    growthPeriod: state.brokerInvestmentFundView.growthPeriod,
    marketCapitalBreakdownData: getMarketCapitalBreakdownData(state, props),
    selectedGlobalStock: state.brokerInvestmentFundView.selectedGlobalStock,
});

const mapDispatchToProps = dispatch => ({
    changeGrowthAmount: amount => dispatch(growthAmountChanged({amount})),
    changeGrowthPeriod: period => dispatch(growthPeriodChanged({period})),
    selectGlobalStock: id => dispatch(globalStockSelected({id})),
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(TabInfo))
